// import React from 'react';
// import { Link } from 'react-router-dom';

// const OrderPage = () => {
//   return (
//     <section className="myntra-order-container py-4">
//       <div className="container">
//         <div className="row justify-content-center align-items-center">
//           <div className="col-lg-10 col-xl-8">
//             <div className="card">
//               <div className="card-header px-4 py-3">
//                 <h5 className="text-muted mb-0">Thanks for your Order, <span className="fw-bold">Vaishnavi</span>!</h5>
//               </div>

//               <div className="card-body p-4">
//                 <p className="fw-bold mb-1">Order Details</p>
//                 <p className="text-muted mb-1">Placed On: 20 Jul 2026</p>
//                 <p className="text-muted mb-1">Order No: <strong>23459876544567</strong></p>
//                 <p className="text-muted mb-3">Total Amount: <strong>₹970</strong></p>
//                 <hr />

//                 <p className="fw-bold mb-1">Shipping Address</p>
//                 <p className="text-muted mb-0">Vaishnavi Channe</p>
//                 <p className="text-muted mb-0">Nit Garden, Trimurti Nagar</p>
//                 <p className="text-muted mb-3">Nagpur - 440022</p>
//                 <hr />

//                 <p className="fw-bold mb-1">Payment Mode</p>
//                 <p className="text-muted mb-3">Cash On Delivery</p>
//                 <hr />

//                 <p className="fw-bold mb-3">Items in this Order</p>

//                 {/* === Product 1 === */}
//                 <div className="card shadow-sm border mb-4">
//                   <div className="card-body">
//                     <div className="row">
//                       <div className="col-md-2">
//                         <img src="https://mdbcdn.b-cdn.net/img/Photos/Horizontal/E-commerce/Products/13.webp" className="img-fluid rounded" alt="Samsung Galaxy" />
//                       </div>
//                       <div className="col-md-10">
//                         <h6 className="fw-bold">Samsung Galaxy</h6>
//                         <p className="mb-1 text-muted">Color: White | Capacity: 64GB</p>
//                         <p className="mb-1 text-muted">Expected Delivery: <strong>25 Jul 2026</strong></p>
//                         <p className="mb-1 text-muted">Seller: <strong>Samsung Store</strong></p>
//                         <p className="mb-1 text-success">Offer Applied: ₹100 off</p>
//                         <p className="mb-1">Qty: <strong>1</strong></p>
//                         <p className="fw-bold text-danger">₹499</p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* === Product 2 === */}
//                 <div className="card shadow-sm border mb-4">
//                   <div className="card-body">
//                     <div className="row">
//                       <div className="col-md-2">
//                         <img src="https://mdbcdn.b-cdn.net/img/Photos/Horizontal/E-commerce/Products/1.webp" className="img-fluid rounded" alt="iPad" />
//                       </div>
//                       <div className="col-md-10">
//                         <h6 className="fw-bold">iPad</h6>
//                         <p className="mb-1 text-muted">Color: Pink Rose | Capacity: 32GB</p>
//                         <p className="mb-1 text-muted">Expected Delivery: <strong>26 Jul 2026</strong></p>
//                         <p className="mb-1 text-muted">Seller: <strong>Apple Retail</strong></p>
//                         <p className="mb-1 text-success">Offer Applied: ₹50 cashback</p>
//                         <p className="mb-1">Qty: <strong>1</strong></p>
//                         <p className="fw-bold text-danger">₹399</p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Order Footer Actions */}
//               <div className="order-footer px-4 py-3 d-flex justify-content-around border-top">
//                 <Link to="/order-cancel" className="order-condition d-flex align-items-center gap-2">
//                   <i className="fa-solid fa-x text-danger"></i>
//                   <button className="btn btn-outline-danger btn-sm">Cancel</button>
//                 </Link>
//                 <Link to="/order-return" className="order-condition d-flex align-items-center gap-2">
//                   <i className="fa-solid fa-right-left text-primary"></i>
//                   <button className="btn btn-outline-primary btn-sm">Return</button>
//                 </Link>
//                 <Link to="/track-order" className="order-condition d-flex align-items-center gap-2">
//                   <i className="fa-solid fa-location-dot text-warning"></i>
//                   <button className="btn btn-outline-warning btn-sm">Track Order</button>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default OrderPage;


import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const OrderPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [colorMap, setColorMap] = useState({});
  const [sizeMap, setSizeMap] = useState({});

  const user_id = localStorage.getItem("user_id");

  useEffect(() => {
    if (user_id) {
      fetchOrders();
      fetchColorList();
      fetchSizeList();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchOrders = async () => {
    try {
      const res = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_new_order",
        { user_id }
      );

      console.log("Orders Response:", res.data);

      if (res.data.status === "true" || res.data.status === true) {
        setOrders(res.data.data || []);
      }
    } catch (error) {
      console.error("Order Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchColorList = async () => {
    try {
      const res = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_color"
      );

      if (res.data?.status) {
        const map = {};
        res.data.colors.forEach((item) => {
          map[item.color_id] = item.color_name;
        });
        setColorMap(map);
      }
    } catch (err) {
      console.error("Color Fetch Error:", err);
    }
  };

  const fetchSizeList = async () => {
    try {
      const res = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_size"
      );

      if (res.data?.status) {
        const map = {};
        res.data.row.forEach((item) => {
          map[item.size_id] = item.size_label;
        });
        setSizeMap(map);
      }
    } catch (err) {
      console.error("Size Fetch Error:", err);
    }
  };

  const getOrderStatus = (order) => {
  if (!order.items || order.items.length === 0) return "Unknown";

  return order.items[0].order_status; // Return | Cancelled | Delivered
};



  if (!user_id) {
    return (
      <div className="container py-5 text-center">
        <h5>Please login to view your orders</h5>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <h5>Loading orders...</h5>
      </div>
    );
  }

  if (orders.length === 0) {
    return (
      <div className="container py-5 text-center">
        <h5>No orders found</h5>
        <Link to="/" className="btn btn-primary mt-3">Continue Shopping</Link>
      </div>
    );
  }

  // Using first order for header details
  const orderInfo = orders[0];

  return (
    <section className="myntra-order-container py-4">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-12 col-xl-12">
            <div className="card">
              {/* Header */}
              <div className="card-header px-4 py-3">
                <h5 className="text-muted mb-0">
                  Thanks for your Order,{" "}
                  <span className="fw-bold">{orderInfo.contact_name || orderInfo.customer_name || "Customer"}</span>!
                </h5>
              </div>

              <div className="card-body p-4">
                {/* ORDERS - Loop through each order */}
                {orders.map((order) => (
                  <div className="card shadow-sm border mb-4" key={order.order_id}>
                    <div className="card-header bg-light">
                      <div className="d-flex justify-content-between align-items-center">
  {/* LEFT: Order ID + Date */}
  <div>
    <strong>Order #{order.order_number || order.order_no}</strong>
    <span className="ms-3 text-muted">
      {order.order_date}
    </span>
  </div>

  {/* RIGHT: Order Status */}
  <div>
    <span
      className={`badge ${
        getOrderStatus(order) === "Delivered"
          ? "bg-success"
          : getOrderStatus(order) === "Cancelled"
          ? "bg-danger"
          : getOrderStatus(order) === "Return"
          ? "bg-primary"
          : "bg-warning text-dark"
      }`}
    >
      {getOrderStatus(order)}
    </span>
  </div>
</div>

                    </div>

                    <div className="card-body">
                      {/* ITEMS - Loop through products in this order */}
                      {order.items && order.items.length > 0 ? (
                        order.items.map((item, itemIndex) => (
                          <div 
                            className={`row ${itemIndex < order.items.length - 1 ? 'border-bottom pb-3 mb-3' : ''}`} 
                            key={`${order.order_id}-${item.product_id}-${itemIndex}`}
                          >
                            <div className="col-md-2">
                              <img
                                src={
                                  item.multi_image
                                    ? `https://cyberathon.com/multivendor/${item.multi_image}`
                                    : "https://via.placeholder.com/100"
                                }
                                alt={item.product_name}
                                className="img-fluid rounded"
                                style={{ maxHeight: "100px", objectFit: "cover" }}
                              />
                            </div>
                            <div className="col-md-7">
                              <h6 className="fw-bold mb-2">{item.product_name}</h6>
                              {item.size && (
                                <p className="mb-1 text-muted">
                                  Size: <strong>{sizeMap[item.size] || item.size}</strong>
                                </p>
                              )}
                              {item.color && (
                                <p className="mb-1 text-muted">
                                  Color: <strong>{colorMap[item.color] || item.color}</strong>
                                </p>
                              )}
                              <p className="mb-1 text-muted">
                                Qty: <strong>{item.qty}</strong>
                              </p>
                              {/* <p className="mb-1 text-muted">
                                Seller ID: <strong>{item.seller_id}</strong>
                              </p> */}
                            </div>
                            <div className="col-md-3 text-end">
                              <p className="fw-bold text-danger mb-2">
                                ₹{item.subtotal || (item.price * item.qty)}
                              </p>
                              <Link 
                                to={`/ProductReview/${user_id}/${order.order_id}/${item.product_id}`} 
                                style={{ textDecoration: 'none' }}
                              >
                                <p className="text-primary mb-2">
                                  <img 
                                    src="/img/rating.png" 
                                    style={{width:"15px", marginRight: "5px"}} 
                                    alt="rating"
                                  />
                                  <span className="text-primary">Rate & Review</span>
                                </p>
                              </Link>
                              <Link to={`/Orderdetails/${order.order_id}/${item.product_id}`}>
                            <button className="btn btn-primary btn-sm mt-2">
                              View Order Details
                            </button>
                          </Link>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p className="text-muted">No items in this order</p>
                      )}

                      {/* Order Summary */}
                      <div className="row mt-3 pt-3 border-top">
                        <div className="col-md-8">
                          <p className="mb-1">
  <strong>Payment Mode:</strong>{" "}
  {order.items?.[0]?.payment_mode || "N/A"}
</p>

<p className="mb-1">
  <strong>Payment Status:</strong>{" "}
  <span
    className={`badge ${
      order.items?.[0]?.payment_status === "Paid"
        ? "bg-success"
        : "bg-warning text-dark"
    }`}
  >
    {order.items?.[0]?.payment_status || "N/A"}
  </span>
</p>

                          <p className="mb-0 text-muted small">
                            <strong>Delivery Address:</strong> {order.contact_full_address || order.contact_address}
                          </p>
                        </div>
                        <div className="col-md-4 text-end">
                          <h5 className="fw-bold text-success">
                            Total: ₹{order.total || order.grand_total}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Footer */}
              <div className="order-footer px-4 py-3 d-flex justify-content-around border-top">
                <Link to="/order-cancel" className="order-condition d-flex align-items-center gap-2">
                  <i className="fa-solid fa-x text-danger"></i>
                  <button className="btn btn-outline-danger btn-sm">Cancel Order</button>
                </Link>

                <Link to="/order-return" className="order-condition d-flex align-items-center gap-2">
                  <i className="fa-solid fa-right-left text-primary"></i>
                  <button className="btn btn-outline-primary btn-sm">Return Order</button>
                </Link>

                <Link to="/track-order" className="order-condition d-flex align-items-center gap-2">
                  <i className="fa-solid fa-location-dot text-warning"></i>
                  <button className="btn btn-outline-warning btn-sm">Track Order</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OrderPage;